import { SDK_CART_ERRORS } from '@photosi/expo-photosi-sdk/build/Cart';

export const extractErrorMessage = (error: any) => {
  if (typeof error === 'string') {
    return error;
  }

  if (typeof error?.message === 'string') {
    return error.message;
  }

  if (!!error && typeof error === 'object') {
    // try to find the first string value
    for (const key in error) {
      if (typeof error[key] === 'string') {
        return error[key];
      }
    }
  }

  return '';
};

export const PRODUCT_NOT_AVAILABLE_ERROR_TYPE = 'PRODUCT_NOT_AVAILABLE';

const hasErrorCode = (error: unknown): error is { errorCode: unknown } =>
  typeof error === 'object' && error !== null && 'errorCode' in error;

export const isProductNotAvailableError = (error: unknown): boolean => {
  if (!hasErrorCode(error) || error.errorCode !== SDK_CART_ERRORS.CART_ROW_BATCH_FAILED) {
    return false;
  }
  const message = extractErrorMessage(error);
  const bodyStart = message.indexOf('{');
  if (bodyStart < 0) {
    return false;
  }
  try {
    return JSON.parse(message.slice(bodyStart))?.type === PRODUCT_NOT_AVAILABLE_ERROR_TYPE;
  } catch {
    return false;
  }
};
